module.exports = __webpack_public_path__ + "static/media/lose-laugh.4f6baea7.wav";